import { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import useAxios, { axiosInstance } from '../../../../../../hooks/useAxios'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { Box, Button, Card, Switch, Typography } from '@mui/material'
import {
  IFacebookOfficialPage,
  IFacebookPage,
} from '../../../../../../types/facebook'
import { FiSave } from 'react-icons/fi'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../../constants/errors'
import { message } from 'antd'
import { isEmpty } from 'radash'

const FacebookPagesLists = () => {
  const [query] = useSearchParams()
  const isPopup = query.get('display') === 'popup'
  const [selectPages, setSelectPages] = useState<IFacebookOfficialPage[]>([])

  const { data, isLoading } = useAxios<IFacebookOfficialPage[]>({
    method: 'GET',
    url: '/facebook/pages',
  })

  const handleClosePopup = useCallback(() => {
    if (window && isPopup) {
      window.close()
    }
  }, [window])

  const handleOnSelectPage = (page: IFacebookOfficialPage) => {
    setSelectPages((prev) => {
      if (prev.find((p) => p.id === page.id)) {
        return prev.filter((p) => p.id !== page.id)
      }
      return [...prev, page]
    })
  }

  const handleOnSave = useCallback(async () => {
    if (isEmpty(selectPages)) {
      message.error('กรุณาเลือกเพจที่ต้องการเชื่อมต่อ')
      return
    }
    try {
      const pages = selectPages.map((page) => ({
        accessToken: page.access_token,
        pageId: page.id,
        pageName: page.name,
        imageUrl: page.image,
        category: page.category,
      }))
      await axiosInstance.post('/facebook/pages/connect', {
        pages,
      })
      handleClosePopup()
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }, [selectPages])

  if (isLoading) {
    return <></>
  }

  return (
    <ContentWrapper>
      <Helmet title="รายชื่อเพจ" />
      <HeaderContent
        goBack
        title="รายชื่อเพจ"
        routes={[] as any}
        descriptions="รายชื่อเพจ"
      />
      <Card
        sx={{
          padding: 4,
          mb: 2,
        }}
      >
        <Typography variant="h5" gutterBottom>
        เชื่อมต่อ Social Media
        </Typography>
        <Box mb={2}>
          <Typography variant="body1">
            จำนวนเพจที่คุณดูแล: {data?.length || 0} เพจ
          </Typography>
        </Box>
        {data?.map((page) => {
          return (
            <Box
              width={'100%'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
              gap={2}
              mb={2}
            >
              <Box display={'flex'} alignItems={'center'} gap={2}>
                <img
                  src={page.image}
                  width="100"
                  height="100"
                  alt={page.name}
                />
                <Box>
                  <Typography variant="h6">{page.name}</Typography>
                  <Typography variant="body1">{page.category}</Typography>
                </Box>
              </Box>
              <Switch
                onChange={() => handleOnSelectPage(page)}
                checked={
                  selectPages.find((p) => p.id === page.id) !== undefined
                }
              />
            </Box>
          )
        })}
      </Card>
      <Box textAlign={'right'}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FiSave />}
          onClick={handleOnSave}
        >
          ยืนยันการเชื่อมแชต
        </Button>
      </Box>
    </ContentWrapper>
  )
}

export default FacebookPagesLists
